import React, { useState } from 'react'
import { useQuery, useLazyQuery } from '@apollo/client'
import styled from 'styled-components'
import Loader from '../../_common/loader'
import FrequentItem from './FrequentItem'
import { GET_FREQUENTLY_BOUGHT_TOGETHER, GET_FREQUENT_ITEMS_INFO } from 'setup/providerGQL'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 460px);
    min-height: 350px;
    overflow-y: scroll;
    > * {
        flex-shrink: 0;
    }
    @media (max-width: 1278px){
		flex-direction: row;
        overflow-x: scroll;
        overflow-y: auto;
        height: 250px;
	}
`

const Main = styled.section`
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    margin: 0 5px 5px;
    position: sticky;
    top: 125px;
`

export default function Frequently(props) {
    const { invMastUid, setShowAddedToCartModal, handleAddedToCart } = props
    const [combinedDetails, setCombinedDetails] = useState([])
    const [itemDetails, setItemDetails] = useState([])

    const { loading } = useQuery(GET_FREQUENTLY_BOUGHT_TOGETHER, {
        variables: { invMastUid },
        fetchPolicy: 'no-cache',
        onCompleted: result => {
            const firstTen = result.frequentlyBoughtTogether?.slice(0, 10)
            const invMastUids = firstTen.map(f => f.invMastUid)
            const items = invMastUids.map(invMastUid => ({
                invMastUid,
                quantity: 1
            }))
            setItemDetails(firstTen)
            getFrequentItemsInfo({ variables: { invMastUids, items } })
        }
    })

    const [getFrequentItemsInfo] = useLazyQuery(GET_FREQUENT_ITEMS_INFO, {
        fetchPolicy: 'no-cache',
        onCompleted: result => {
            // console.log(result)
            combineData(result)
        }
    })

    function combineData(result) {
        const { getItemPrices, itemAvailability } = result
        const combined = itemDetails.map(d => {
            const { invMastUid } = d
            const availability = itemAvailability.find(a => a.invMastUid === invMastUid)
            const price = getItemPrices.find(a => a.invMastUid === invMastUid)
            return {
                itemDetails: d,
                availability,
                price
            }
        })
        setCombinedDetails(combined)
    }

    const frequentDisplay = combinedDetails.map((r, i) => {
        return (
            <FrequentItem {...{
                ...r,
                handleAddedToCart,
                key: i
            }} />
        )
    })

    return (
        <div style={{maxWidth: "100%" /* Prevents a pixel pop related to scrollbars. Eliminates need for vw calc in the media query*/}}>
            {!loading ? (
                combinedDetails.length > 0 && (
                    <Main>
                        <h2>Frequently Purchased Together</h2>
                        <Container>
                            {frequentDisplay}
                        </Container>
                    </Main>
                )
            ) : <Loader />}
        </div>
    )
}